import {
  SurfaceLineFeature3D,
  SurfaceLineSelectionType,
} from './procedural/SurfaceLineFeature3D'
import React from 'react'
import { GeckoComponentPath, GeckoGenericHeadCircumferentialWeld } from 'types'

import { FeatureLabel3D } from './procedural/FeatureLabel3D'
/**
 * A component used to render a single Circumferential weld on a component's surface
 * @param model             The asset model for this Circumferential weld
 * @constructor
 */
export const GenericHeadCircumferentialWeldFeature3D: React.FC<{
  model: GeckoGenericHeadCircumferentialWeld
}> = ({ model }) => {
  const path = React.useMemo(() => {
    return GeckoComponentPath.CreateFromHorizontalLine(model.feature_geometry)
  }, [model.feature_geometry])

  return (
    <group name={model.id}>
      <SurfaceLineFeature3D
        path={path}
        featureModel={model}
        lineSelectionType={SurfaceLineSelectionType.SelectableFeatureLine}
      />
      <FeatureLabel3D
        feature={model}
        coords={model.feature_geometry.end}
        anchor={'top left'}
        showBoundaryLabelIn2D
      />
    </group>
  )
}
